import * as yup from 'yup';
import { Row, RenderConfig, Column, TextInput, SelectInput, EMPTY_ARRAY, AsyncSelect } from 'commons-ui';
import { INTERNAL_ENTITY_TYPE_OPTIONS, INTERNAL_USER_TYPE_OPTIONS } from './constants';

export const FORM_FIELD_KEYS = {
	managerName: 'managerName',
	oe: 'oe',
	ut: 'ut',
	e: 'e',
	et: 'et'
};

export const editValidationSchema = yup.object().shape({
	oe: yup.string().required('Official Email is a required field'),
	managerName: yup.string().required('Manager Email is a required field'),
	ut: yup.string().required('User Type is a required field')
});

export const addValidationSchema = yup.object().shape({
	oe: yup.string().required('Official Email is a required field'),
	managerName: yup.string().required('Manager Email is a required field'),
	ut: yup.string().required('User Type is a required field'),
	e: yup
		.string()
		.required('Entity is a required field')
		.transform(function (value) {
			// If value is a 10-digit number, add +91
			if (/^\d{10}$/.test(value)) {
				return `+91${value}`;
			}
			return value;
		})
		.test('is-email-or-indian-phone', 'Must be a valid email or Indian phone number (+91XXXXXXXXXX)', function (value) {
			if (!value) return true;
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			const phoneRegex = /^\+91\d{10}$/;
			return emailRegex.test(value) || phoneRegex.test(value);
		}),
	et: yup
		.string()
		.required('Entity Type is a required field')
		.test('match-entity-type', 'Entity Type does not match Entity value', function (value) {
			const { e } = this.parent;
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			const phoneRegex = /^\+91\d{10}$/;
			if (phoneRegex.test(e)) {
				return value === 'PHONE';
			}
			if (emailRegex.test(e)) {
				return value === 'EMAIL';
			}
			return true;
		})
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.oe]: new RenderConfig()
		.setName('oe')
		.setLabel('Email')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { add: false, edit: false }, required: true }),
	[FORM_FIELD_KEYS.managerName]: new RenderConfig()
		.setName('managerName')
		.setLabel('Manager Name')
		.setRenderer(AsyncSelect)
		.setRenderProps({
			isEditable: { add: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.ut]: new RenderConfig()
		.setName('ut')
		.setLabel('User Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { add: false, edit: true },
			required: true,
			options: INTERNAL_USER_TYPE_OPTIONS
		}),
	[FORM_FIELD_KEYS.e]: new RenderConfig()
		.setName('e')
		.setLabel('Phone/Email')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { add: true, edit: true },
			placeholder: 'Enter Phone/Email',
			required: true
		}),
	[FORM_FIELD_KEYS.et]: new RenderConfig()
		.setName('et')
		.setLabel('Entity Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { add: true, edit: true },
			required: true,
			options: INTERNAL_ENTITY_TYPE_OPTIONS
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.oe)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.managerName)]), new Column([new Row(FORM_FIELD_KEYS.ut)])])
];

export const FORM_LAYOUT_CONFIG_ADD = [
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.oe)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.managerName)]), new Column([new Row(FORM_FIELD_KEYS.ut)])]),
	new Row(null, EMPTY_ARRAY, [new Column([new Row(FORM_FIELD_KEYS.e)]), new Column([new Row(FORM_FIELD_KEYS.et)])])
];
